document.addEventListener('DOMContentLoaded',function(){
  var swiper = new Swiper(".HH_LoopSubWorksOutr", {
      slidesPerView: 1.2,
      spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    breakpoints: {
      768: {
        slidesPerView: 2.1,
        spaceBetween: 10
      },
    1024: {
      slidesPerView: 3.11,
      spaceBetween: 10
    },
  }
  });
})